module.exports = "/_next/static/images/privacy@3x-8069a87d30a29710e7f515bd5b9f6e15.png";